import React, { useEffect, useState } from 'react'
import TableWrapper from '../../../../component/TableWrapper';
import { Icons } from '../../../../assets';
import { useNavigate } from 'react-router-dom';
import request from '../../../../service';
import Exported from '../../../../service/endpoints';
import { useDispatch } from 'react-redux';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';
import { Toast } from '../../../../service/toast';
import ModalDropdown from '../../../../component/ModalDropdown'
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, useForm } from 'react-hook-form';

import classes from "./style.module.scss"
import Button from '../../../../component/Button'
import InputBox from '../../../../component/InputBox'

const FeedbackList = ({ handlePageChange, searchInput, getProductList, handleClick, page, setPage, productTableList, setProductTableList, isLoading, setisLoading, sortConfig, setSortConfig }) => {

    const COMPLETED = 'Completed'
    const NEW_ENQUIRY = 'New'
    const IN_PROGRESS = 'In Progress'

    const [isOpen, setIsOpen] = useState(false)
    const [prodId, setProdId] = useState()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const formMethods = useForm({
        mode: 'onSubmit',
    });
    const {
        handleSubmit,
        formState: { errors },
        register,
        trigger,
        resetField,
    } = formMethods;

    const userHeader = [
        { label: 'Feedback ID', sortable: 'enquiry_id' },
        { label: 'Customer Name', sortable: 'username' },
        { label: 'Customer Type', sortable: 'role' },
        { label: 'Product Type', sortable: 'product_id' },
        { label: 'Enquiry Date', sortable: 'enquiry_date' },
        { label: 'Status', sortable: 'status' },
        { label: 'Actions' },
    ];

    const handleData = (keyValue, defaultValue, className = '') => {
        return (
            <td className={`${className}`}>{keyValue ? keyValue : defaultValue}</td>
        )
    };

    // const redirectTo = (id) => {
    //     navigate(`?id=${id}`)
    // }

    const handleStatus = (id) => {
        setProdId(id)
        setIsOpen(true);
    }

    const closePopUp = () =>{
        setIsOpen(false)
    }

    const onSubmit = async (data) =>{
        // dispatch(saveLoadingState(true))
        await request({
            url: `${Exported.Endpoints.feebackItem}?feedback_id=${prodId}`,
            method: Exported.APIMethods.PUT,
            data: {
                status: 3,
                admin_comment : data.reason,
            }
        }).then(async (res) => {
            if (res?.data?.status) {
                await getProductList(true)
                setIsOpen(false)
                resetField('reason')
                Toast({
                    type: 'success',
                    message: 'Status updated successfully'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
        // dispatch(saveLoadingState(false))
    }
    return (
        <>
            <div className={`eventWrapper`}>
                <div className={`mt-2 mb-5`}>
                    <TableWrapper
                        headerDetails={userHeader}
                        pageMeta={productTableList?.pageMeta}
                        handlePageChange={setPage}
                        listLength={productTableList?.result || []}
                        isLoading={isLoading}
                        sortConfig={sortConfig}
                        setSortConfig={setSortConfig}
                    >
                        {productTableList?.result?.map((item, index) => {
                            const { id = '', user = '', product = '', feedback_date = '', status = '', product_feedback_id='', custType='' } = item;
                            const dateConvert = new Date(feedback_date);
                            const monthName = dateConvert.toLocaleString('en-US', { month: 'long' });
                            let date = `${dateConvert.getDate()} ${monthName} ${dateConvert.getFullYear()}`;

                            return (
                                <tr key={product_feedback_id}>
                                    {handleData(product_feedback_id, '-', 'text-center')}
                                    {handleData(user?.name || '-', '-', 'text-center')}
                                    {handleData(user?.role?.name || '-', '-', 'text-center')}
                                    {handleData(product?.category?.title || '-', '-', 'text-center')}
                                    {handleData(date, '-', 'text-center')}
                                    <td className=" px-3 mx-auto text-center">
                                        <div className='' style={{
                                            color: status === 3 ? '#01CB46' :
                                                status === 1 ? '#FC0000' : status === 2 ? '#D99E27' : '#000000'
                                        }}>
                                            {status === 3 ? 'Completed' :
                                                status === 1 ? 'New' : status === 2 ? 'In Progress' : ""}
                                        </div>
                                    </td>
                                    <td className=" px-3 mx-auto text-center action-button">
                                        <div className='flex items-center justify-center'>
                                            <img src={Icons.eye} alt='View' className='cursor-pointer w-[20px] h-[20px]' onClick={() => handleClick(product_feedback_id)}  />
                                            <img src={Icons.checked} alt='Done' className='cursor-pointer w-[22px] h-[22px] mx-2' onClick={() => status === 3 ? null : handleStatus(product_feedback_id)} />
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}

                    </TableWrapper>
                </div>
            </div>
            { isOpen ? <ModalDropdown isOpen={isOpen} closePopUp={closePopUp}>
                <div className={`${classes.reasonModalWrapper}`}>
                    <div className={`${classes.modalHeader} flex items-center justify-between`}>
                        <div className={`${classes.modalTitle}`}>Add Internal Comment</div>
                        <div className={`${classes.modalCloser}`}>
                            <CloseIcon onClick={() => closePopUp()} />
                        </div>
                    </div>
                    <div className={`${classes.reasonFormContainer}`}>
                        <FormProvider {...formMethods}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className={`${classes.formGroup}`}>

                                </div>
                                <div className={`${classes.formField}`}>
                                    <InputBox
                                        label={"Comment"}
                                        className={`w-[100%] ${classes.notesInput}`}
                                        name={"reason"}
                                        type={"textarea"}
                                        {...register("reason", {
                                            required: true,
                                        })}
                                        error={errors.reason}
                                        messages={{
                                            required: "Reason is required",
                                        }}
                                    />
                                </div>
                                <div className='flex justify-end'>
                                    <Button text={"Submit"} className={`w-[100%] my-4`} smallBtn />
                                </div>
                            </form>
                        </FormProvider>
                    </div>
                </div>
            </ModalDropdown> : null}
        </>
    )
}

export default FeedbackList